import { BlogSection } from "@/types/blog";

export const quellen: BlogSection = {
  id: "quellen",
  title: "Quellen und wissenschaftliche Basis",
  content: `
    <h3>Neurowissenschaft und Immunregulation</h3>
    <ul>
      <li>Tracey K. J. (2023). <em>Nature Reviews Immunology.</em> Vagusnerv und antiinflammatorischer Reflex</li>
      <li>Dantzer R., Kelley K. (2021). <em>Nature Reviews Neuroscience.</em> Sickness Behaviour als adaptives Muster</li>
      <li>Miller G. E., Chen E. (2021). <em>Nature Medicine.</em> Chronischer Stress und Cortisolresistenz</li>
      <li>Slavich G. M. (2022). <em>Nature Human Behaviour.</em> Stress, soziale Sicherheit und Entzündung</li>
      <li>Cole S. W. et al. (2022). <em>PNAS.</em> Soziale Isolation und Entzündungsmarker</li>
    </ul>
    
    <h3>Verhaltenspsychologie und Selbstregulation</h3>
    <ul>
      <li>Davidson R. J. et al. (2022). <em>Trends in Cognitive Sciences.</em> Präfrontale Regulation durch Achtsamkeit</li>
      <li>Neff K. D., Germer C. (2023). <em>Mindfulness.</em> Selbstmitgefühl und Stressbiologie</li>
      <li>Porges S. (2018). <em>The Pocket Guide to the Polyvagal Theory</em></li>
    </ul>
    
    <h3>Gesellschaft und Organisation</h3>
    <ul>
      <li>Bock C. et al. (2024). <em>Journal of Occupational Health Psychology.</em> Erholungskultur und Leistung</li>
    </ul>
  `
};
